import { render, staticRenderFns } from "./signUp.vue?vue&type=template&id=96e65eda&scoped=true&"
import script from "./signUp.vue?vue&type=script&lang=js&"
export * from "./signUp.vue?vue&type=script&lang=js&"
import style0 from "./signUp.vue?vue&type=style&index=0&id=96e65eda&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e65eda",
  null
  
)

export default component.exports